import { TTheme } from '@/core/theme'
import { CustomButton } from '@atbay/component-lib'
import { styled } from '@mui/system'

export const TriggerWrapper = styled('div')`
    width: fit-content;
    height: fit-content;
    cursor: pointer;
`

export const StyleButton = styled(CustomButton)<{ theme?: TTheme }>`
    width: fit-content;
    font-size: var(--font-size-xs);
`

export const Header = styled('div')<{ theme?: TTheme }>`
    display: flex;
    gap: 10px;
    margin-bottom: 8px;
    align-items: center;
`

export const Footer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    gap: 8px;
    justify-content: end;
    margin-top: 12px;

    .cancel-button {
        display: flex;
        justify-content: end;
        max-width: 40px;
        margin-right: -26px;
        padding-right: 48px;
    }
`
